// DOM CustomEvent used by the admin-app shell (Vue) to open the persistent
// New Content modal that lives inside the content-studio React island.
// The modal listens for this event on `document`; entry points dispatch it.
export const OPEN_NEW_CONTENT_MODAL_EVENT = 'cl:open-new-content-modal';

export enum NewContentModalStep {
  WorkspaceUpload = 1,
  ClipCuration = 2
}
